import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, Button, } from "reactstrap"

import { connect } from "react-redux";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";

import { Modal } from "react-bootstrap";
import Loader from "components/Loader/Loader";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { deleteBatch, fetchAllBatchOfTrainer, updateBatch } from "helpers/batch_helper";

const MyBatches = (props) => {
    document.title = "Content Management | All Groups";
    const [modalShow, setModalShow] = useState(false);
    const [name, setName] = useState("");
    const [id, setId] = useState({});
    const [spanDisplay, setSpanDisplay] = useState("none");
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [loader, setLoader] = useState(false);
    const [allBatch, setAllBatch] = useState([]);
    const navigate = useNavigate();


    const breadcrumbItems = [
        { title: "Batch", link: "#" },
        { title: "My Batches", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems('My Batches', breadcrumbItems)
    })

    useEffect(() => {
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])

    const getAllBatches = async () => {
        try {
            setLoader(true);
            const result = await fetchAllBatchOfTrainer();
            if (result?.success) {
                setAllBatch(result?.result);
            }
            else {
                toast.error(result?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setLoader(false);
        }

    }


    useEffect(() => {
        getAllBatches();
    }, []);


    const data = {
        columns: [
            {
                label: "Serial No.",
                field: "serialNo",
                sort: "asc",
                width: 50,
            },
            {
                label: "Batch Name",
                field: "batchName",
                sort: "asc",
                width: 50,
            }
        ],
        rows: allBatch?.map((row, index) => ({
            ...row,
            serialNo: index + 1, // Add 1 to start counting from 1
            clickEvent: () => handleRowClick(row),
        })),
    };


    const handleRowClick = (row) => {

        setModalShow(true);
        navigate(`/batch/${row.id}`)
        setId(row.id);
        setName(row.name);
    }

    const handleUpdate = async () => {
        if (!name) {
            setSpanDisplay("inline")

        }
        else {

            try {
                setLoader(true);

                const result = await updateBatch({ id, batchName: name });

                if (result?.success) {
                    toast.success(result?.message);
                    getAllBatches();
                    setModalShow(false);
                    setName("");
                    setId("");
                }
                else {
                    toast.error(result?.message);
                }
            } catch (error) {
                toast.error(error?.response?.data?.message);
            } finally {
                setLoader(false);
            }



        }
    }




    const handleDelete = async () => {
        try {
            setLoader(true)
            const result = await deleteBatch(id);
            if (result?.success) {
                toast.success(result?.message);
                getAllBatches();
                setModalShow(false);
                setDeleteModalShow(false)
                setName("");
                setId("");
            }
            else {
                toast.error(result?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setLoader(false);
        }

    }

    return (
        <React.Fragment>
            {loader ? (
                <Loader />
            ) : ("")}
            <Row  >
                <Col className="col-12">
                    <Card>
                        <CardBody className="col-lg-6 col-sm-12 col-xs-12"   >
                            <CardTitle className="h4">All Batches </CardTitle>
                            <MDBDataTable className="table-row-hover" responsive bordered data={data} style={{ cursor: 'pointer' }} noBottomColumns />
                        </CardBody>

                    </Card>
                </Col>
            </Row>

            <Modal
                show={modalShow}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Edit Batch
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Batch Name
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter new Batch"
                                maxLength="50"
                                value={name}
                                onChange={(e) => setName(e.target.value)} />
                            {!name && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setModalShow(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleUpdate} className="waves-effect waves-light">Update</Button>{" "}
                    <Button type="button" color="danger" onClick={() => { setDeleteModalShow(true); setModalShow(false) }} className="waves-effect waves-light">Delete</Button>{" "}
                </Modal.Footer>
            </Modal>
            <Modal
                show={deleteModalShow}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>

                    <h4>
                        Are you sure want to remove this Batch.
                    </h4>


                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => { setDeleteModalShow(false); setModalShow(true) }} className="waves-effect waves-light">No</Button>{" "}
                    <Button type="button" color="danger" onClick={handleDelete} className="waves-effect waves-light">Yes</Button>{" "}

                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(MyBatches);